import React from 'react';
import { TypologyNameDiv } from './styled';

const CarouselContent = ({ selectedSet }) => {
  return (
    <>
      {selectedSet.typologies?.map((typology) => (
        <TypologyNameDiv key={typology.id}>{typology.name}</TypologyNameDiv>
      ))}
    </>
  );
};

export default CarouselContent;
